/**
 * GoldFire Network (https://goldfire.me)
 * Copyright (c) 2012 - 2020, GoldFire Studios, Inc.
 * http://goldfirestudios.com
 */

import Vue from 'vue';
import Vuex from 'vuex';
import {createState} from './state';
import * as mutations from './mutations';

let actions;
if (typeof window !== 'undefined') {
  actions = require('./actions');
}

Vue.use(Vuex);

// Export the store factory.
export function createStore() {
  // Create the global data store with Vuex.
  const store = new Vuex.Store({
    state: createState(),
    mutations,
    actions,
  });

  // Enable hot updates to mutations and actions.
  if (module.hot) {
    module.hot.accept([
      './actions',
      './mutations',
    ], () => {
      store.hotUpdate({
        actions: require('./actions'),
        mutations: require('./mutations'),
      });
    });
  }

  return store;
}
